"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var users;
        (function (users) {
            var map;
            (function (map) {
                class InitArgs {
                    constructor() {
                        this.userGroups = [];
                        this.usersFilter = [];
                        this.userLatLng = appn.emptyString;
                        this.userHasDataEntryAccess = false;
                        this.dateFilter = appn.emptyString;
                        this.usersEdit = appn.emptyString;
                        this.usersMapData = appn.emptyString;
                    }
                }
                let _initArgs;
                let _historyEnabled;
                let _pagingToolbar;
                let _mapMain;
                let _users;
                let _topPopupContent = appn.emptyString;
                let _isTop = true;
                function init(args) {
                    _initArgs = args;
                    createPagingToolbar();
                    createMapMain();
                    addEvents();
                }
                map.init = init;
                appn.pubSub.subscribe(appn.pubSub.WINDOW_RESIZED, function (channel, data) {
                    if (!_mapMain || !_mapMain.map)
                        return;
                    _mapMain.map.invalidateSize();
                });
                function addEvents() {
                    appn.dialog.showLoading();
                    appn.dateFilter.init(_initArgs.dateFilter);
                    $('.users-legend .acc-collapse-button').on('click', function () {
                        if ($(this).hasClass('collapsed')) {
                            $(this).find('.fa.fa-chevron-up').show();
                            $(this).find('.fa.fa-chevron-down').hide();
                        }
                        else {
                            $(this).find('.fa.fa-chevron-up').hide();
                            $(this).find('.fa.fa-chevron-down').show();
                        }
                    });
                    _mapMain.usersColorClasses = [];
                    $('.users-legend ul li').each(function (i, item) {
                        var _a, _b, _c;
                        const colorClasses = (_c = (_b = (_a = $(item)) === null || _a === void 0 ? void 0 : _a.attr('class')) === null || _b === void 0 ? void 0 : _b.split(' ')) !== null && _c !== void 0 ? _c : [];
                        colorClasses.forEach(function (colorClass, index) {
                            if (colorClass.contains('color-brand-'))
                                _mapMain.usersColorClasses.push({ userId: $(item).prop('id'), colorClass: colorClass });
                        });
                    });
                    _mapMain.setColorBy(appn.emptyString);
                    $('#ColorByUser').off().on('change', function () {
                        _mapMain.setColorBy('users');
                        _mapMain.getMapDataFromServer(true);
                    });
                    _pagingToolbar.init();
                    _mapMain.getMapDataFromServer(true);
                }
                function createPagingToolbar() {
                    _pagingToolbar = {
                        init: function () {
                            $('#GoPrevious').on('click', function () {
                                if (!appn.ui.isElementDisabled($('#GoPrevious'))) {
                                    _pagingToolbar.pageNum--;
                                    _mapMain.getMapDataFromServer();
                                }
                            });
                            $('#GoNext').on('click', function () {
                                if (!appn.ui.isElementDisabled($('#GoNext'))) {
                                    _pagingToolbar.pageNum++;
                                    _mapMain.getMapDataFromServer();
                                }
                            });
                        },
                        pageSize: 100,
                        pageNum: 1,
                        totalUsers: 0,
                        updateUi: function () {
                            let totalText = T('No results found');
                            if (_pagingToolbar.totalUsers > 0) {
                                const totalRecs = _pagingToolbar.totalUsers;
                                const startRec = ((_pagingToolbar.pageSize * _pagingToolbar.pageNum) - _pagingToolbar.pageSize) + 1;
                                const lastRec = Math.min((_pagingToolbar.pageSize * _pagingToolbar.pageNum), totalRecs);
                                totalText = T('Showing {0} to {1} of {2} users', startRec, lastRec, totalRecs);
                            }
                            $('#TotalsText').html(totalText);
                            if ((_pagingToolbar.pageSize * _pagingToolbar.pageNum) < _pagingToolbar.totalUsers)
                                appn.ui.enableElement($('#GoNext'));
                            else
                                appn.ui.disableElement($('#GoNext'));
                            if (_pagingToolbar.pageNum > 1)
                                appn.ui.enableElement($('#GoPrevious'));
                            else
                                appn.ui.disableElement($('#GoPrevious'));
                        }
                    };
                }
                function createMapMain() {
                    _mapMain = {
                        map: appn.ui.mapInit('mapMain', 0, 0, 11, false),
                        markersAdded: [],
                        totalEntries: 0,
                        totalUsers: 0,
                        noLatLongEntries: 0,
                        firstPopup: new L.Marker(new L.LatLng(0, 0)),
                        locationsToRender: [],
                        usersColorClasses: [],
                        updateTotalEntries: function () {
                            _mapMain.totalUsers = _pagingToolbar.totalUsers;
                            let totalText = '<i class="fa fa-search text-danger"></i><span class="ml-2">' + T('No results found') + '</span>';
                            if (_mapMain.totalEntries > 0)
                                totalText = T('<b>{0}</b> locations for <b>{1}</b> Users', _mapMain.totalEntries, _mapMain.totalUsers);
                            const currentDateSelection = $('.appnDateFilter li.active .appnDateFilter-typeName').text();
                            totalText += T(' for {0}', currentDateSelection.toLowerCase());
                            $('.header-text .totalShowing').html(totalText);
                        },
                        removeMarkers: function () {
                            _mapMain.markersAdded.forEach((marker) => {
                                _mapMain.map.removeLayer(marker);
                                _mapMain.markersAdded = [];
                            });
                        },
                        setColorBy: function (colorBy) {
                            if (colorBy === appn.emptyString) {
                                colorBy = appn.localStorage.getItem('map_defaultColorBy');
                                if (!colorBy)
                                    colorBy = 'users';
                            }
                            appn.localStorage.setItem('map_defaultColorBy', colorBy);
                            if (colorBy === 'users')
                                $('#ColorByUser').prop('checked', true);
                        },
                        renderDataOnMap: function () {
                            createMap_renderDataOnMap();
                        },
                        getMapDataFromServer: function () {
                            createMap_getMapDataFromServer(true);
                            _pagingToolbar.updateUi();
                            _mapMain.updateTotalEntries();
                        }
                    };
                }
                function createMap_renderDataOnMap() {
                    _mapMain.removeMarkers();
                    _mapMain.locationsToRender = [];
                    _mapMain.firstPopup = new L.Marker(new L.LatLng(0, 0));
                    const latlng = _initArgs.userLatLng.split(',');
                    let firstEntryLatLng = new L.LatLng(latlng[0], latlng[1]);
                    const bounds = [];
                    let mostRecentDate = new Date(0);
                    let mostRecentLatLong = new L.LatLng(0, 0, 1);
                    let mostRecentPopup = new L.Marker(mostRecentLatLong);
                    _users.forEach((user) => {
                        const markers = getMarkerData(user);
                        markers.forEach((marker) => {
                            _mapMain.locationsToRender.push(marker);
                        });
                    });
                    _mapMain.totalEntries = _pagingToolbar.totalUsers;
                    if (_historyEnabled)
                        _mapMain.totalEntries = _mapMain.locationsToRender.length;
                    const markers = L.markerClusterGroup();
                    _mapMain.locationsToRender.forEach((locationToRender, index) => {
                        const lat = locationToRender.lat;
                        const lon = locationToRender.lon;
                        if (mostRecentDate === (new Date(0)))
                            mostRecentDate = locationToRender.timeStamp;
                        const newCoordinate = new L.LatLng(lat, lon, 1);
                        bounds.push(newCoordinate);
                        const pinColourClass = locationToRender.colorClass;
                        const pinUserColor = locationToRender.userColorCode;
                        let icon = new L.DivIcon();
                        if ($('#ColorByUser').prop('checked') === true) {
                            if (pinUserColor) {
                                let htmlPin = `<div class="appn-mapPin" opacity: 0.7;" style="background-color:${pinUserColor}; border-color:${pinUserColor};">`;
                                if (_historyEnabled)
                                    htmlPin += `<div class="map-pin-number">${locationToRender.locationIndex + 1}</div>`;
                                htmlPin += `</div><div class="appn-mapShadow" style="background-color:${pinUserColor}; border-color:${pinUserColor};"></div>`;
                                icon = L.divIcon({
                                    html: htmlPin,
                                    className: 'dummy'
                                });
                            }
                            else {
                                let htmlPin = `<div class="appn-mapPin ${pinColourClass}" opacity: 0.7;">`;
                                if (_historyEnabled)
                                    htmlPin += `<div class="map-pin-number">${locationToRender.locationIndex}</div>`;
                                htmlPin += `</div><div class="appn-mapShadow ${pinColourClass}"></div>`;
                                icon = L.divIcon({
                                    html: htmlPin,
                                    className: 'dummy'
                                });
                            }
                        }
                        else {
                            let htmlPin = `<div class="appn-mapPin ${pinColourClass}">`;
                            if (_historyEnabled)
                                htmlPin += `<div class="map-pin-number">${locationToRender.locationIndex + 1}</div>`;
                            htmlPin += `</div><div class="appn-mapShadow ${pinColourClass}"></div>`;
                            icon = L.divIcon({
                                html: htmlPin,
                                className: 'dummy'
                            });
                        }
                        const newMarker = new L.Marker(newCoordinate, { icon: icon });
                        markers.addLayer(newMarker);
                        let buttons = appn.emptyString;
                        if (buttons.hasValue())
                            buttons += '<br />';
                        const popupText = `<div class="appnMapPopup" data-locationid="${locationToRender.id}_${index}">
                <h5>${locationToRender.title}</h5><span>
                <span><i class="fa fa-clock"></i> Seen ${locationToRender.locationTime}</span><br>
                <a class="btn btn-link btn-sm pb-0" href="${getDataUrl(locationToRender.id)}">${T('View User')}</a><br>
                <span class="text-muted leaflet-popup-gpsstring"><i class="fa fa-map-marker"></i> ${lat} ${lon}</span></div>`;
                        const popup = newMarker.bindPopup(popupText).on('popupopen', function (popup) {
                            $('abbr.timeago').timeago();
                            _isTop = popup.popup._content === _topPopupContent;
                        });
                        if (locationToRender.timeStamp > mostRecentDate) {
                            mostRecentDate = locationToRender.timeStamp;
                            mostRecentPopup = popup;
                            mostRecentLatLong = newCoordinate;
                            _topPopupContent = mostRecentPopup._popup._content;
                        }
                    });
                    _mapMain.map.addLayer(markers);
                    _mapMain.markersAdded.push(markers);
                    _mapMain.firstPopup = mostRecentPopup;
                    firstEntryLatLng = mostRecentLatLong;
                    if (_mapMain.firstPopup.getLatLng().lat === firstEntryLatLng.lat &&
                        _mapMain.firstPopup.getLatLng().lat !== 0 &&
                        _mapMain.firstPopup.getLatLng().lng === firstEntryLatLng.lng &&
                        _mapMain.firstPopup.getLatLng().lng !== 0)
                        _mapMain.firstPopup.openPopup();
                    if (bounds.length > 0)
                        _mapMain.map.fitBounds(getMapBounds(bounds));
                    else
                        _mapMain.map.setView(new L.LatLng(latlng[0], latlng[1]), 6);
                }
                function getMapBounds(latLngs) {
                    const mapBounds = new L.LatLngBounds(latLngs[0], latLngs[0]);
                    latLngs.forEach((point) => {
                        mapBounds.extend(point);
                    });
                    return mapBounds;
                }
                function getMarkerData(user) {
                    const mapPoints = [];
                    _mapMain.totalEntries = 0;
                    if ($('#enableHistory').is(':checked'))
                        _historyEnabled = true;
                    const colorToAdd = appn.emptyString;
                    let colorClassToAdd = appn.emptyString;
                    if (user.MapLocationPoints.length > 0) {
                        _pagingToolbar.totalUsers++;
                        if ($('#ColorByUser').prop('checked'))
                            $(_mapMain.usersColorClasses).each(function (i, item) {
                                if (item.userId === user.ApiId) {
                                    if (item.colorClass)
                                        colorClassToAdd = item.colorClass;
                                    return false;
                                }
                            });
                        if (_historyEnabled)
                            user.MapLocationPoints.forEach((mapLocationPoint, index) => {
                                const mapPoint = new LocationInfo(user.Id, `${user.LastName}, ${user.FirstName}`, colorToAdd, colorClassToAdd, index, mapLocationPoint.Latitude, mapLocationPoint.Longitude, mapLocationPoint.TimeAgo, new Date(Number(mapLocationPoint.TimeStamp) * 1000), user.UserColorCode);
                                mapPoints.push(mapPoint);
                            });
                        if (!_historyEnabled) {
                            const mapPoint = new LocationInfo(user.Id, `${user.LastName}, ${user.FirstName}`, colorToAdd, colorClassToAdd, 0, user.MapLocationPoints[0].Latitude, user.MapLocationPoints[0].Longitude, user.MapLocationPoints[0].TimeAgo, new Date(Number(user.MapLocationPoints[0].TimeStamp) * 1000), user.UserColorCode);
                            mapPoints.push(mapPoint);
                        }
                    }
                    return mapPoints;
                }
                function getDataUrl(userId) {
                    return _initArgs.usersEdit + '/' + userId;
                }
                function createMap_getMapDataFromServer(resetPaging) {
                    appn.dialog.showLoading();
                    if (resetPaging)
                        _pagingToolbar.pageNum = 1;
                    _historyEnabled = appn.dataTable.getStateOrDefault('enableHistory', $('#enableHistory').is(':checked')).value;
                    const userToFilterBy = appn.dataTable.getStateOrDefault('userFilter', $('#userFilter').val());
                    if (!userToFilterBy.value || userToFilterBy.value === 'All')
                        userToFilterBy.value = appn.emptyString;
                    const appnDateFilterValue = appn.dateFilter.getStateOrDefault();
                    const params = appn.location.buildQueryString([
                        { name: 'v', value: new Date().getTime() },
                        { name: 'userFilterId', value: userToFilterBy.value },
                        { name: 'dateFilter', value: appnDateFilterValue.type },
                        { name: 'dateFilterFrom', value: encodeURIComponent(appnDateFilterValue.fromDate) },
                        { name: 'dateFilterTo', value: encodeURIComponent(appnDateFilterValue.toDate) },
                        { name: 'pageSize', value: _pagingToolbar.pageSize },
                        { name: 'pageNum', value: (_pagingToolbar.pageNum - 1) }
                    ]);
                    let userGroupFilterParam = appn.emptyString;
                    if (_initArgs.userGroups.length > 0) {
                        const userGroupToFilterBy = appn.dataTable.getStateOrDefault('userGroupFilter', $('#userGroupFilter').val());
                        if (!userGroupToFilterBy.value || userGroupToFilterBy.value === 'All')
                            userGroupToFilterBy.value = appn.emptyString;
                        userGroupFilterParam = `&userGroupFilterId=${userGroupToFilterBy.value}`;
                    }
                    const url = _initArgs.usersMapData + params + userGroupFilterParam;
                    appn.ajax.post({
                        url: url,
                        dataType: 'json',
                        done: function (data) {
                            _users = data;
                            _pagingToolbar.totalUsers = 0;
                            getMapDataFromServerAjaxPostDone();
                        },
                        fail: function () {
                            appn.dialog.alert({
                                modalColor: 'modal-danger',
                                title: T('Map Data Load Failed'),
                                message: T('Failed to load map data.  Please sign out and sign in again.  Contact support if this problem persists.'),
                                buttons: {
                                    ok: {
                                        label: '<span>' + T('OK') + '</span>',
                                        className: 'btn-success'
                                    }
                                },
                                autoHeaderIcon: false
                            });
                            appn.dialog.hideLoading();
                        }
                    });
                }
                function getMapDataFromServerAjaxPostDone() {
                    _mapMain.renderDataOnMap();
                    _pagingToolbar.updateUi();
                    $('.mapHeader .header-filters').html(appn.emptyString);
                    appn.sideFilterAndContent.appendShowButton($('.mapHeader .header-filters '));
                    $('.mapHeader .header-filters ').prepend(appn.elementBuilder.buildSelect(_initArgs.usersFilter, 'userFilter', 'saveMeState'));
                    if (_initArgs.userGroups.length > 0)
                        $('.mapHeader .header-filters ').prepend(appn.elementBuilder.buildSelect(_initArgs.userGroups, 'userGroupFilter', 'saveMeState'));
                    if (_mapMain.locationsToRender.length > 0) {
                        $('.mapHeader .header-filters ').prepend(`<button id="btnShowMostRecent" title="${T('Displays the popup for the most recent User Map Pin.')}" class="btn-sm btn btn-info ml-2">${T('Latest')}</button>`);
                        $('#btnShowMostRecent').off().on('click', function (e) {
                            e.preventDefault();
                            const shake = _isTop;
                            _mapMain.firstPopup.openPopup();
                            if (shake)
                                appn.utils.shake($(_mapMain.firstPopup._popup._wrapper));
                            $('abbr.timeago').timeago();
                        });
                    }
                    $('.mapHeader .header-filters').prepend(appn.elementBuilder.buildCheckbox(T('Show History'), 'saveMeState', 'enableHistory'));
                    appn.popover.init();
                    appn.saveMeState.init(function () {
                        _pagingToolbar.totalUsers = 0;
                        _mapMain.getMapDataFromServer(true);
                    }, function () {
                        _mapMain.setColorBy('users');
                        _mapMain.getMapDataFromServer(true);
                        _historyEnabled = false;
                    }, '.mapHeader .header-filters ');
                    _mapMain.updateTotalEntries();
                    appn.select.init();
                    appn.dialog.hideLoading();
                }
                class UserMapDetail {
                    constructor() {
                        this.Id = 0;
                        this.ApiId = appn.emptyGuid;
                        this.DeviceCount = 0;
                        this.Email = appn.emptyString;
                        this.ExternalId = appn.emptyString;
                        this.FirstName = appn.emptyString;
                        this.HasWebAccess = false;
                        this.LastName = appn.emptyString;
                        this.LastUpdated = new Date();
                        this.Level = appn.emptyString;
                        this.LocationHistory = [];
                        this.MapLocationPoints = [];
                        this.Status = appn.UserStatus.Inactive;
                        this.Type = appn.UserType.Standard;
                        this.UserColorCode = appn.emptyString;
                    }
                }
                class LocationInfo {
                    constructor(id, title, color, colorClass, locationIndex, lat, lon, locationTime, timeStamp, userColorCode) {
                        this.id = 0;
                        this.title = T('Unknown User');
                        this.color = appn.emptyString;
                        this.colorClass = appn.emptyString;
                        this.locationIndex = -1;
                        this.lat = 0;
                        this.lon = 0;
                        this.locationTime = appn.emptyString;
                        this.timeStamp = new Date(0);
                        this.userColorCode = appn.emptyString;
                        this.id = id;
                        if (title.hasValue())
                            this.title = title;
                        this.color = color;
                        this.colorClass = colorClass;
                        this.locationIndex = locationIndex;
                        this.lat = lat;
                        this.lon = lon;
                        this.locationTime = locationTime;
                        this.timeStamp = timeStamp;
                        this.userColorCode = userColorCode;
                    }
                }
            })(map = users.map || (users.map = {}));
        })(users = views.users || (views.users = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
